/* PB Pre-order Info — scroll-linked timeline "flow".
   The whole timeline (a vertical tube + a circle at each step) is drawn as ONE
   SVG shape filled with a single shared gradient, so every circle and the line
   are perfectly in sync / continuous. A moving waterline reveals that shape
   top-down: the waterline sits at the CENTRE of the viewport, so as the user
   scrolls, whatever is at screen-centre is where the line/fill currently is —
   each circle fills as it passes the middle of the screen, and drains again on
   the way back up (fully reversible). Base black circles sit under the fill, so
   at rest the dots are solid black and unconnected. If this never runs, the dots
   just stay black (safe fallback). */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';

  function mk(name, attrs) {
    var e = document.createElementNS(NS, name);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }

  function init(root) {
    if (root.__pbPoInit) return;
    root.__pbPoInit = true;

    var svg = root.querySelector('.pb-po__flow');
    if (!svg) return;
    var grad = svg.querySelector('linearGradient');
    var reveal = svg.querySelector('.pb-po__reveal');
    var baseG = svg.querySelector('.pb-po__flow-base');
    var fillG = svg.querySelector('.pb-po__flow-fill');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.pb-po__num'));
    if (dots.length < 2 || !grad || !reveal || !baseG || !fillG) return;

    var R = 18;      // circle radius (matches the 36px number placeholders)
    var TUBE = 6;    // connecting line thickness
    var geo = null;

    // (Re)draw the base circles + gradient tube/circles from the live dot
    // positions, and stretch the shared gradient across the whole shape.
    function build() {
      var b = root.getBoundingClientRect();
      var W = b.width, H = b.height;
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      var cs = dots.map(function (d) {
        var r = d.getBoundingClientRect();
        return { x: r.left + r.width / 2 - b.left, y: r.top + r.height / 2 - b.top };
      });
      var cx = cs[0].x, top = cs[0].y, bot = cs[cs.length - 1].y;

      // One gradient spanning the full shape → every part is in sync.
      grad.setAttribute('x1', cx); grad.setAttribute('y1', top - R);
      grad.setAttribute('x2', cx); grad.setAttribute('y2', bot + R);

      while (baseG.firstChild) baseG.removeChild(baseG.firstChild);
      while (fillG.firstChild) fillG.removeChild(fillG.firstChild);
      // tube first (behind circles), then a circle per node
      fillG.appendChild(mk('rect', { x: cx - TUBE / 2, y: top, width: TUBE, height: Math.max(0, bot - top), rx: TUBE / 2 }));
      cs.forEach(function (c) {
        baseG.appendChild(mk('circle', { cx: c.x, cy: c.y, r: R }));
        fillG.appendChild(mk('circle', { cx: c.x, cy: c.y, r: R }));
      });

      reveal.setAttribute('x', 0);
      reveal.setAttribute('y', 0);
      reveal.setAttribute('width', W);
      geo = { top: top - R, bot: bot + R };
    }

    // Waterline = centre of the viewport. Progress is how far that centre line
    // has travelled through the shape (0 above the top, 1 below the bottom).
    function update() {
      if (!geo) return;
      var b = root.getBoundingClientRect();
      var centre = window.innerHeight * 0.5;
      var span = geo.bot - geo.top;
      var p = (centre - (b.top + geo.top)) / span;
      if (p < 0) p = 0; else if (p > 1) p = 1;
      reveal.setAttribute('height', geo.top + p * span);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }
    function remeasure() { build(); update(); }

    build();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasure);
    window.addEventListener('load', remeasure);
    setTimeout(remeasure, 300);
    setTimeout(remeasure, 1000);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-pb-po-steps]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
